import { useEffect, useState } from 'react';

import { UseDataTableFiltersResponse } from './use-data-table-filters';
import { UseDataTableSortResponse } from './use-data-table-sort';

interface UseDataTableList {
  filters: UseDataTableFiltersResponse;
  sort: UseDataTableSortResponse;
}
export const useDataTableList = <T>(data: T[], props: UseDataTableList) => {
  const { filters, sort } = props;
  const [list, setList] = useState(data || []);

  useEffect(() => {
    if (data.length === 0) {
      return;
    }
    let newData = data;
    newData = data?.filter((item: any) => {
      const matched = Object.entries(filters?.filters).filter(
        ([field, value]) => {
          return String(item[field])
            .toLocaleLowerCase()
            .includes(String(value).toLocaleLowerCase());
        }
      );
      return matched.length === Object.keys(filters?.filters).length;
    });
    if (sort.sortField) {
      newData?.sort((prev: any, next: any) => {
        if (prev?.[sort?.sortField] === next?.[sort?.sortField]) {
          return 0;
        } else if (prev?.[sort?.sortField] >= next?.[sort?.sortField]) {
          return sort.sortDirection === 'desc' ? -1 : 1;
        }
        return sort.sortDirection === 'desc' ? 1 : -1;
      });
    }
    setList(newData);
  }, [filters.filters, sort.sortField, sort.sortDirection, data]);
  return {
    list,
  };
};
